import { createFileRoute } from "@tanstack/react-router";

import { ActiveAttributeRendererWrapper } from "../-components";
import { SectionWrapper, prefetchActiveCatalog } from "../-shared";
import type { DeviceCatalogSection } from "../-shared/-query";
import { SectionGroupContent as SharedSectionGroupContent } from "../../../../-components/shared";

export const Route = createFileRoute(
  "/_staff/device-catalog/active/$id/_layout/profile/",
)({
  component: ActiveProfile,
  loader: prefetchActiveCatalog,
});

function ActiveProfile() {
  return (
    <SectionWrapper
      renderContent={(props) => {
        if ("sectionGroup" in props) {
          return (
            <SharedSectionGroupContent
              sectionGroup={props.sectionGroup}
              readonly={true}
              renderAttributes={(section: DeviceCatalogSection) => (
                <ActiveAttributeRendererWrapper
                  attributes={section.attributes}
                  sectionKey={String(section.sectionKey)}
                />
              )}
            />
          );
        }
        return null;
      }}
    />
  );
}
